// extracted by mini-css-extract-plugin
export default {"page":"yPHgi","inner":"iq8AP","blocks":"DhmFv","theoryBlock":"UyxL8","actions":"Lc9Ah"};